import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { GenericResponse, PortalUsers } from 'src/app/interfaces/apiresponses'; 
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { RestService } from 'src/app/services/rest/rest.service';
import { IItem } from '@coreui/angular-pro'
import * as _ from 'lodash';

@Component({
  selector: 'app-admin-checker',
  templateUrl: './admin-checker.component.html',
  styleUrls: ['./admin-checker.component.scss']
})
export class AdminCheckerComponent implements OnInit {
  constructor(private restApi: RestService, private changeDetector: ChangeDetectorRef){

  }

  ngOnInit() {
    this.getAllPortalUsers()
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  bUndefined!:boolean

  // Selected Customer Details
  selectedItem: any = {}
  usersData: IItem[] = []

  columns = [
    {
      key: 'name',
      _style: { width: '20vw', minWidth: '10vw', maxWidth: '30vw' },
    },
    'emailId',
    'mobileNumber',
    {
      key: 'portalRoleName',
      label: 'Role',
      _cellProps: {align: 'middle'},
      filter: true
    },    
  ];


  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {})
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any){
    this.bAlert = event?.state
    //console.log(this.bAlert)
    switch (event?.data?.action){
      case 1:
        this.getAllPortalUsers()
        break
      default:
        break
    }
  }

  closeAlert(event: any){
  
  }

  alertVisibility(event: any){
    this.bAlert = event.state
  }

  // Reject Form
  bShowReason = false
  bValidReason!: boolean
  rejectionReason: string = ''
  rejectionForm = new FormGroup({
    reasonControl: new FormControl(this.rejectionReason, [Validators.required, Validators.minLength(5)])
  })

  get reasonControl() { return this.rejectionForm.get('reasonControl') }

  ifReasonValid(){
    if (this.reasonControl?.invalid && (this.reasonControl?.dirty || this.reasonControl?.touched)){
      this.bValidReason = false
      return 'Enter a valid reason'
    } else {
      if (this.reasonControl?.dirty || this.reasonControl?.touched)
        this.bValidReason = true
      else
        this.bValidReason = this.bUndefined
      return ''
    }
  }

  showReasonModal(){
    this.reasonControl?.setValue('')
    this.rejectionReason = ''
    this.bValidReason = this.bUndefined
    this.bShowReason = true
  }

  closeReasonModal(){
    this.bShowReason = false
  }

  RejectCustomer() {
    if (this.rejectionForm.valid){
      this.bShowReason = false

      this.restApi.approveOrDisapprovePortalUser(this.selectedItem.userId, false, this.reasonControl?.value == undefined ? "Rejected" : this.reasonControl?.value).subscribe({
        next: (v: GenericResponse) => {
          if (v.success){
            this.getAllPortalUsers()
          } else {
            this.showAlertBox('Sorry', 'There was a technical issue. Please try later')
          }
        },
        error: (e) => {
          this.showAlertBox('Sorry', 'There was a technical issue. Please try later')
        }
      })
    }
  }

  // Approval and rejection alert
  bShowActivationReason: boolean = false
  selectedUserName: string = ""
  bValidActivationRejectReason!: boolean
  activationRejectionReason: string = ''
  bShowApproveReason:boolean = false;
  activationRejectionForm = new FormGroup({
    activationReasonControl: new FormControl(this.activationRejectionReason, [Validators.required, Validators.minLength(5)])
  })

  get activationReasonControl() { return this.activationRejectionForm.get('activationReasonControl') }

  ifActivationReasonValid(){
    if (this.activationReasonControl?.invalid && (this.activationReasonControl?.dirty || this.activationReasonControl?.touched)){
      this.bValidActivationRejectReason = false
      return 'Enter a valid reason'
    } else {
      if (this.activationReasonControl?.dirty || this.activationReasonControl?.touched)
        this.bValidActivationRejectReason = true
      else
        this.bValidActivationRejectReason = this.bUndefined
      return ''
    }
  }

  showActivationReasonModal(item: any){
    this.selectedItem = item
    this.selectedUserName = item.name
    
    this.activationReasonControl?.setValue('')
    this.activationRejectionReason = ''
    this.bValidActivationRejectReason = this.bUndefined
    this.bShowActivationReason = true
  }

  closeActivationReasonModal(){
    this.bShowActivationReason = false
    
  }
  closeApproveReasonModal(){
    this.bShowApproveReason =false
    this.getAllPortalUsers()
  }
  activateUserPrompt(){
    this.bShowActivationReason=false;
    this.showAlertBox('Confirm', 'User approved successfully!', 'No', true, 'Yes', {action: 1})
  }
  approveActivationRequest(state: boolean){
    this.bShowActivationReason = false

    if (state){
      
      this.restApi.approveOrDisapprovePortalUser(this.selectedItem.userId, true, '').subscribe({
        next: (v: GenericResponse) => {
          if (v.success){
            
            //this.showAlertBox('Confirm', 'Approved successfully!', 'Cancel')
           this.bShowApproveReason =true
          } else {
            this.showAlertBox('Sorry', 'There was a technical issue. Please try later')
          }
        },
        error: (e) => {
          this.showAlertBox('Sorry', 'There was a technical issue. Please try later')
        }
      })
    } else {
      this.showReasonModal()
    }
  }

  rowSelected = (clickedItem: any) =>{
    this.showActivationReasonModal(clickedItem.item);
  }

  ifPending(data:any){
    if (data.isDecisionTaken)
      return false
    else
      return true
  }

  getAllPortalUsers(){
    this.restApi.getAllPortalUsers().subscribe({
      next: (v: PortalUsers) => {
        if (v.success){
          /*this.usersData = v.dhabiPortalUsers.map((item, userId) => {
              return {
                ...item
              };
            })*/
          this.usersData = v.dhabiPortalUsers.filter(this.ifPending).map((item, userId) => {
            return {
              ...item
            }
          })
        }
      },
      error: (e) => {

      }
    })
  }
}
